import React, { memo } from 'react'
import Spinner from '@purecarslabs/signal-components/baseline/Spinner'
import { FormContentPropsType } from './types'
import { SkeletonWrapper } from './styles'

export const FormContentSkeleton: React.FC<FormContentPropsType> = ({
  isEmbedded = false
}) => {
  return (
    <SkeletonWrapper $isEmbedded={isEmbedded}>
      <Spinner />
    </SkeletonWrapper>
  )
}

export default memo(FormContentSkeleton)
